<template>
  <div>
    
    <!-- ShiftStore -->

  </div>
</template>

<script>


import _ from 'lodash'
const paymentTypes = {
  0: 'Cash',
  4: 'Debit',
  2: 'Credit',
  1: 'Cheque',
  3: 'Gift Card',

  'Cash' : 0,
  'Debit': 4,
  'Credit': 2,
  'Cheque': 1,
  'Gift Card': 3,
}

export default {
  name: 'ShiftStore',
  data () { return { 
    locations: {

    }
    } 
  },
  created(){
    this.$locations.forEach(location=>{
      this.$set(this.locations, location, []);
    })
  },
  methods:{
    // double check if this works
    debounceLoadData(location, numOfShifts=10){
      console.log(`Debounce loading Data for ${location}`);
      return _.debounce(() => {
        this.loadData(location, numOfShifts)
      }, 800)
    },
    loadData(location, numOfShifts=10) {
      // options.include = [
        //   { model: 'departments', attributes: ['Description'], required : true, include:['category']}, 
      // ];
      console.log(`Loading Data for ${location}`);
      const options = {}
      options.limit = numOfShifts;
      options.include = [
        {model: 'shiftsMediaTypes'},
        {model: 'shiftsMediaTypesCount'},
        {model: 'shiftsJson'},
        
      ]
      options.attributes = ["RowID","StartDateTime","EndDateTime","IDUsed","NetSalesTaxed","NetSalesNonTaxed"]//,"NetSalesTaxExempt","Tax1","Tax2","Tax3","TaxOther","TotalNumTrans","Open_Cashier_ID","Close_Cashier_ID","Close_Out_Index","CashbackAmount","Tax4","Tax5","Tax6"]
      // options.where = {StartDateTime : {"$gte": '2020-01-01'}, StartDateTime : {"$lt": '2020-01-5'}} 
      options.order = [['StartDateTime', 'DESC'],]
      this.locations[location] = [];
      this.$axios.get(`/api/${location}/shifts`, {params:options}).then((s)=>{
        
        if (Array.isArray(s.data) && s.data.length > 0)
          console.log(JSON.stringify(Object.keys(s.data[0])));

        if (!Array.isArray(s.data) ){
          console.log('ERROR', options)
          return;
        }
        
        let defaultData = {
          cashiers:[], 
          safe:0,
          coin:0,
          backupTerminal:0,
          // charges:0,
          deductions:{
            charges: 0,
            thefts: 0,
            errors: 0,
          },
          payAtPump:0,
          note:'',
        }
        defaultData = JSON.stringify(defaultData)
        s.data.forEach(r => r.shiftsJson = r.shiftsJson === null ? {RowID: r.RowID, data:JSON.parse(defaultData)} : {RowID: r.shiftsJson.RowID, data:JSON.parse(r.shiftsJson.data)})

        //Tmp fix for schema change
        s.data.forEach(r => {
          if(r.shiftsJson.data.cashiers[0] === 'Jaimin'){
            console.log('DEBUG NEW', r)
          }
          if(r.shiftsJson.data.charges !== undefined && r.shiftsJson.data.deductions === undefined){
            r.shiftsJson.data.deductions = {
              charges: r.shiftsJson.data.charges ,
              thefts: 0,
              errors: 0,
            }
            delete r.shiftsJson.data.charges
          }
        })
        
        // console.log(s.data)
        this.locations[location] = s.data
      });
    },
    saveEdit(location, row){
      console.log(`Saving Data for ${location}`);
      const updateData = {
        RowID : row.RowID,
        data : JSON.stringify(row.shiftsJson.data)
      }
      this.$axios.patch(`/api/${location}/shiftsJson/`, updateData).then((r)=>{
        //Should Do Something Here
        console.log('Should Do Something Here', r)
      });
    },
    shiftsMediaTypeForKey(row, key){
      const t = paymentTypes[key]
      const arr = row.shiftsMediaTypes.filter(r=>r.MediaType === t)
      return arr.length === 0 ? {} : arr[0]
    },
    shiftsMediaTypeCountForKey(row, key){
      const t = paymentTypes[key]
      const arr = row.shiftsMediaTypesCounts.filter(r=>r.MediaType === t)
      return arr.length === 0 ? {} : arr[0]
    },
    overShort(row){
      let s,c,bt,tc,dc,dt,de;
      try{
        
        const _n = val => val === null || val === undefined || val === '' ? 0 : parseFloat(val)
        const n = val => val === NaN ? 0: val;
        s = n(row.shiftsJson.data.safe);
        c = n(row.shiftsJson.data.coin);
        bt = n(row.shiftsJson.data.backupTerminal);
        tc = n(this.shiftsMediaTypeForKey(row,'Cash').MediaTotal)
        dc = n(row.shiftsJson.data.deductions.charges)
        dt = n(row.shiftsJson.data.deductions.thefts)
        de = n(row.shiftsJson.data.deductions.errors)
        // console.log(s,c,bt,tc,dc,dt,de)
        
  
        return numeral(s).add(c).add(bt).subtract(tc).subtract(dc).subtract(dt).subtract(de).value()
      }
      catch(e){
        console.log("Error with overShort", e, row)
        // console.log(s,c,bt,tc,dc,dt,de)
        return 'NA';
      }
    },
    //Quick and dirty, needs WORK
    shiftsWithTotals(location){
      let result = []
      let tmpShifts = []
      this.locations[location].forEach(r=>{
        tmpShifts.push(r);
        if(r.IDUsed === '10011'){
          const totalShift = {"StartDateTime": "", "EndDateTime": "", "IDUsed" : 'total', shiftsMediaTypes: [], shiftsMediaTypesCounts: [], "NetSalesTaxed": 0, "NetSalesNonTaxed": 0, shiftsJson:{data:{cashiers:[],deductions:{charges: 0,thefts: 0,errors: 0,},}}}
          const spacerShift = {"StartDateTime": "", "EndDateTime": "", "IDUsed" : '', shiftsMediaTypes: [], shiftsMediaTypesCounts: [], "NetSalesTaxed": 0, "NetSalesNonTaxed": 0, shiftsJson:{data:{cashiers:[],deductions:{charges: 0,thefts: 0,errors: 0,},}}}
          tmpShifts.forEach(rt=>{
              // console.log('DEBUG numeral', totalShift["NetSalesTaxed"], rt["NetSalesTaxed"])
              const addForKey = key => totalShift[key] = numeral(totalShift[key] === null ? 0 : totalShift[key]).add(rt[key] === null ? 0 : rt[key])
              
              addForKey("NetSalesTaxed")
              addForKey("NetSalesNonTaxed")
            // totalShift["NetSalesTaxed"] = numeral(totalShift["NetSalesTaxed"]).add(rt["NetSalesTaxed"])
            // totalShift["NetSalesNonTaxed"] = numeral(totalShift["NetSalesNonTaxed"]).add(rt["NetSalesNonTaxed"])
            // rt["NetSalesTaxed"] = numeral(totalShift["NetSalesTaxed"]).add(rt["NetSalesTaxed"])
            // rt["NetSalesTaxed"] = numeral(totalShift["NetSalesTaxed"]).add(rt["NetSalesTaxed"])
            // rt["NetSalesTaxed"] = numeral(totalShift["NetSalesTaxed"]).add(rt["NetSalesTaxed"])
          })
          
          result = [...result, ...tmpShifts]//, totalShift, spacerShift];
          tmpShifts = [];
        } 
      })
      
      return result;
    }
  },
  computed:{

    
  }
}
</script>